// When a detail page (e.g. /properties/:id) wants the sidebar to highlight
// a specific child item (e.g. "Черновики" instead of the default first child),
// it dispatches `setSidebarOverride(path)` on mount. Sidebar reads this and
// uses it as the active child when pathname doesn't directly match.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface SidebarOverrideState {
	childPath: string | null
}

interface SliceRoot { sidebarOverride: SidebarOverrideState }

const initialState: SidebarOverrideState = { childPath: null }

const slice = createSlice({
	name: 'sidebarOverride',
	initialState,
	reducers: {
		setSidebarOverride(state, action: PayloadAction<string | null>) {
			state.childPath = action.payload
		},
	},
})

export const { setSidebarOverride } = slice.actions
export const sidebarOverrideReducer = slice.reducer
export const selectSidebarOverride = (s: SliceRoot) => s.sidebarOverride.childPath
